import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import ReactDOM from "react-dom";

import { checkAMLob } from "utils/checkAMLob";
import { media } from "utils/style";

class LandingPageTabs extends Component {
  handleClick = flow => {
    const form = document.createElement("form");
    form.method = "post";
    form.action = "/privacy/secure/your-data";

    const hiddenField = document.createElement("input");
    hiddenField.type = "hidden";
    hiddenField.name = "apples";
    hiddenField.value = flow;

    form.appendChild(hiddenField);

    document.body.appendChild(form);
    form.submit();
  };

  render() {
    const { landing_page_tabs } = this.props;

    return checkAMLob() &&
      window.reactGlobals.oneVZ === "Y" &&
      window.reactGlobals.oneVZEnabled === "Y" &&
      landing_page_tabs
      ? ReactDOM.createPortal(
        <Div shouldBannerRender={this.props.shouldBannerRender} {...this.props}>
          <div>
            <Button
              onClick={() => this.handleClick("red")}
              selected={checkAMLob() === "vzw"}
              aria-label="wireless mobile privacy dashboard"
              role="link"
            >
              {landing_page_tabs.wireless}
            </Button>
            <Button
              onClick={() => this.handleClick("green")}
              selected={checkAMLob() === "vzt"}
              aria-label="wireline home privacy dashboard"
              role="link"
            >
              {landing_page_tabs.wireline}
            </Button>
          </div>
        </Div>,
        document.getElementById("oneVZTabs")
      )
      : null;
  }
}

const mapStateToProps = ({ downloadAndDelete: { shouldBannerRender } }) => ({
  shouldBannerRender
});

export default connect(mapStateToProps)(LandingPageTabs);

const Div = styled.div`
  max-width: 1272px;
  margin: 24px auto 19px auto;
  border-bottom: 1px solid #D8D8D8;
  padding-bottom: 9px;

  div {
    padding: 0 20px;
  }

  ${media.mobile`
    margin: 24px 16px 19px 16px;  

    div {
      padding: 0;
    }
  `}
  /* margin: ${({ shouldBannerRender }) => (shouldBannerRender ? "64px 0 -56px 0" : "30px 0 -50px 0")};

  ${media.mobile`
    margin-bottom: -20px;
    margin-top: 40px;
  `} */
`;

const Button = styled.button`
  :first-of-type {
    margin-right: 20px;
  }

  background: 0;
  cursor: pointer;
  border: 0;
  font-size: 14px;
  line-height: 16px;
  font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
  padding: 8px 0 0 0;

  ${({ selected }) =>
    selected &&
    `
    border-top: 4px solid #D0021B;
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-weight: 700;
  `}

  ${media.mobile`
    font-size: 12px;
    line-height: 14px;
  `}
`;
